// **************************************************
// Input focus style
// **************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  document.querySelectorAll('.mod-input').forEach((input) => {
    input.addEventListener('focus', () => input.classList.add('is-focused'));
    input.addEventListener('blur', () => input.classList.remove('is-focused'));
  });
});
